const ACCOUNT_TEXT_ALLOWED = /^[\u0020-\u007E]*$/;
export const ACCOUNT_TEXT_MAX_LENGTH = 200;

export function isValidAccountText(text: string): boolean {
  return ACCOUNT_TEXT_ALLOWED.test(text) && text.length <= ACCOUNT_TEXT_MAX_LENGTH;
}

export const ACCOUNT_TEXT_SPECIAL_CHARS_MESSAGE = 'Special characters are not allowed';
export const ACCOUNT_TEXT_MAX_LENGTH_MESSAGE = 'No more than 200 characters are allowed';

export function notifyInvalidAccountText(text: string): void {
  if (!ACCOUNT_TEXT_ALLOWED.test(text)) {
    globalThis.QEP.notification.local.error(ACCOUNT_TEXT_SPECIAL_CHARS_MESSAGE);
    return;
  }

  globalThis.QEP.notification.local.error(ACCOUNT_TEXT_MAX_LENGTH_MESSAGE);
}
